module.exports = __webpack_public_path__ + "static/media/stageArrow.38ff5acc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/stageArrow.svg
// module id = 300
// module chunks = 0